export enum CddVolumeOptions {
  UNDER_TEN_K = 'UNDER_TEN_K',
  TEN_K_TO_FIFTY_K = 'TEN_K_TO_FIFTY_K',
  FIFTY_K_TO_HUNDRED_K = 'FIFTY_K_TO_HUNDRED_K',
  HUNDRED_K_TO_TWO_HUNDRED_K = 'HUNDRED_K_TO_TWO_HUNDRED_K',
  OVER_TWO_HUNDRED_K = 'OVER_TWO_HUNDRED_K',
}

export const CDD_VOLUME_OPTIONS: CddVolumeOptions[] = Object.values(CddVolumeOptions);
